<template>
  <div>
    <div class="title">{{getText}}</div>
    <Coupon :couponBatchList="couponBatchList"/>
  </div>
</template>
<script>
import Coupon from './coupon.vue'
export default {
  name: 'CouponList',
  props: ['couponBatchList', 'status'],
  components: {
    Coupon
  },
  computed: {
    getText () {
      // 1可购买,2已购买（频次超限
      const statusText = {
        1: this.$t('FoodC_C_You_will_pQqU', {n: this.couponBatchList.length}),
        2: this.$t('FoodC_C_You_have_EjAA')
      }
      return statusText[this.status] || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-family: "Aspira Medium";
  font-size: 36px;
  color: #000000;
  font-weight: 500;
  line-height: 36px;
  margin: 40px 40px 32px 40px;
}
</style>